<script>
import forminput from "../formcomponet/forminput.vue";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import authenticate from "@/models/authenticate";
//import mznlogin from "./mzn-login";
import mznfirmalogin from "./mznfirma-login";
export default {
  mixins: [apibtoast, apigeneric, authenticate],
  props: {
    WebSiteConfig: [String, Object],
  },
  page: {
    title: "Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
   // mznlogin,
    mznfirmalogin,
    forminput,
  },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      FormData: {},
      ErrorMessage: null,
      userres: null,
      userData: null,
      Kvkk: false,
      kullanicituru: null,
    };
  },
  methods: {
    KvkkOnay() {
      this.userData.Kvkk = true;
      this.userData.Kvkkonaytarihi = new Date();
      this.Update(
        this.$config.API_URL_2 + this.kullanicituru,
        this.userData
      ).then((mznres) => {
        if (mznres) {
          this.SetLogin(this.userres).then((responseset) => {
            if (responseset) {
              window.location.href = "/";
            }
          });
        }
      });
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.ActionsLogin(this.FormData).then((res) => {
          if (res.Succeeded != false) {

          this.SetLogin(res);

            this.ActionsFilterGet({
              Service: this.$config.API_URL_2 + "mznmezunlar",
              Page: this.Page,
              Filter: "&Userid=" + res.Id,
            }).then((response) => {
              if (response.Data.length > 0) {
                this.userData = response.Data[0];

                console.log("userData",JSON.stringify(this.userData))
                
                if (
                  (response.Data[0].Kvkk &&
                    this.WebSiteConfig.Kvkktarihi <
                      response.Data[0].Kvkkonaytarihi) ||
                  !this.WebSiteConfig.Kvkk
                ) {
                  this.SetLogin(res).then((responseset) => {
                    if (responseset) {
                        const bosMu = (v) =>  v === null ||  v === undefined ||  v === "" ||  v === "null";

                      if(bosMu(this.userData.Calismadurumu) ||
                        bosMu(this.userData.AlanIsIlgiliMi) ||
                        bosMu(this.userData.Eposta) ||
                        bosMu(this.userData.KisiselEposta) ||
                        bosMu(this.userData.Telefon) ||
                        bosMu(this.userData.Evadresi) ||
                        bosMu(this.userData.Yesilisalani)){
                        window.location.href = "/profilzorunlubilgiler";
                      }else{
                        window.location.href = "/";
                      }

                    }
                  });
                } else {
                  this.kullanicituru = "mznmezunlar";
                  this.$bvModal.show("kvkkmetni");
                }
              } else {
                this.ActionsFilterGet({
                  Service: this.$config.API_URL_2 + "mznfirma",
                  Page: this.Page,
                  Filter: "&Userid=" + res.Id,
                }).then((responsefirma) => {
                  if (responsefirma.Data.length > 0) { 
                    this.userData = responsefirma.Data[0];
                    if (
                      (responsefirma.Data[0].Kvkk &&
                        this.WebSiteConfig.Kvkktarihi <
                          responsefirma.Data[0].Kvkkonaytarihi) ||
                      !this.WebSiteConfig.Kvkk
                    ) {
                      this.SetLogin(res).then((responseset) => {
                        if (responseset) {
                          window.location.href = "/";
                        }
                      });
                    } else {
                      this.kullanicituru = "mznfirma";
                      this.$bvModal.show("kvkkmetni");
                    }
                  }
                });
              }
              //Bu bölümü idari personel için açtım
              this.SetLogin(res)
              window.location.href = "/";
              //--------------------------------
            });
          } else {
            this.ErrorMessage = res.Message;
            this.loginbutton = false;
          }
        });
      }
    },
    Get() {},
  },
  created() {
    //this.ActionsLogin(this.$cookie.get("ecampusmzn"));
    //window.location.href = "/";
  },
  mounted() {
    this.FormData = this.authenticateData;
  },
};
</script>

<template>
  <div class="login-page">
    <div class="row">
      <div class="col-md-5 left-bar">
        <div class="row c-flex flex-column justify-content-between p-4 h-100">
          <div class="col-md-12 c-flex">
            <div class="logo">
              <img src="/assets/images/Kurum_Logo.png" alt="" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="text-area text-center">
              <p class="title">Mezun Bilgi Sistemi</p>
       <!--      <p class="text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
                voluptas cupiditate id, totam doloremque eius, cumque atque
                consequatur, aspernatur optio repellat nihil unde temporibus
                itaque nostrum voluptatibus modi odio accusantium!
              </p> --> 
            </div>
          </div>
          <div class="col-md-12">
            <div class="copyright">
              {{ new Date().getFullYear() - 1 }} -
              {{ new Date().getFullYear() }} {{ this.$t("Footer.Sol") }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7 right-bar mt-5">
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{
                $t("authenticate.Page.Kullanicigiris")
              }}</span>
            </template>
            <div class="login-form mt-5">
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <Form @submit.prevent="onSubmit">
                    <div class="row">
                      <div class="mb-3">
                        <forminput
                          :FormDataType="FormDataType.Email"
                          :Value="FormData.Email"
                          :v="$v.FormData.Email"
                          @input="FormData.Email = $event"
                        />
                      </div>
                      <div class="mb-3">
                        <forminput
                          :FormDataType="FormDataType.Password"
                          :Value="FormData.Password"
                          :v="$v.FormData.Password"
                          @input="FormData.Password = $event"
                        />
                      </div>
                    </div>

                    <div class="title mt-3">
                      <p class="erormesssage">{{ ErrorMessage }}</p>
                    </div>

                    <div class="mb-3">
                      <a href="/forgot-password" class="link-primary"><u>Şifremi Unuttum</u></a>
                    </div>
                    <button class="btn btn-primary" type="submit">
                      {{ $t("authenticate.AddEdit.Button") }}
                    </button>
                  </Form>
                </div>
              </div>
            </div>
          </b-tab>
    <!--     <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{
                $t("authenticate.Page.Ogrencikayit")
              }}</span>
            </template>
            <mznlogin :Kvkk="WebSiteConfig.Kvkkmetni" />
          </b-tab> --> 
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{
                $t("authenticate.Page.Firmakayit")
              }}</span>
            </template>
            <mznfirmalogin :Kvkk="WebSiteConfig.Kvkkmetni" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal
      id="kvkkmetni"
      size="lg"
      :title="$t('kvkkmetni.FormTitle')"
      title-class="font-18"
      hide-footer
    >
      <div class="mt-5">
        <div class="mt-5">
          {{ WebSiteConfig.Kvkkmetni }}
          <b-form-group :label="$t('kvkkmetni.Check')" label-for="text">
            <b-form-checkbox
              value="true"
              unchecked-value="false"
              v-model="Kvkk"
            ></b-form-checkbox>
          </b-form-group>

          <button
            class="btn btn-primary"
            type="submit"
            :disabled="Kvkk == 'false'"
            @click="KvkkOnay()"
          >
            {{ $t("kvkkmetni.Button") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" module></style>
